import {Component, Input, OnInit} from '@angular/core';
import {DocumentModel} from '../../models/document.model';

@Component({
    selector: 'order-number',
    templateUrl: './order-number.component.html',
    styleUrls: ['./order-number.component.scss'],
})
export class OrderNumberComponent implements OnInit {

    @Input() document: DocumentModel;

    constructor() {
    }

    ngOnInit() {
        if (this.document.parentDocument) {
            this.document.orderNumber = '' + this.document.parentDocument.documentNumber;
        }
    }

}
